interface Props {
  children: React.ReactNode
  classNames?: string
  bgGradient?: string
}

export default function CurriculumOnboardingWrapper({ children, classNames, bgGradient }: Props): React.ReactElement {
  return (
    <div
      className={`relative h-full min-h-screen w-full text-black-light flex flex-col items-center ${
        bgGradient ? bgGradient : 'bg-purple-portal-background'
      } ${classNames || ''}`}
    >
      <section className="w-full h-full flex justify-center text-white">{children}</section>
    </div>
  )
}
